import React from "react";
import { createRoot } from 'react-dom/client';
import App from "./App";

import 'bootstrap/dist/css/bootstrap.min.css';
import './common/styles/style.css';
import './common/styles/app.css';


const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
